const actionTypes = { SET_SMART_SKIN_SCAN_CONTENT: 'SET_SMART_SKIN_SCAN_CONTENT' };

module.exports = actionTypes;
